import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'react-redux';
import type { ReviewListResponse, ReviewListState } from './types';

export const reviewList = (state: RootState) => state.reviewList;

export const getReviewsList = createSelector(reviewList, (state: ReviewListState) => state.data);

export const getIsFetchingReviewList = createSelector(
  reviewList,
  (state: ReviewListState) => state.isFetching,
);

export const getMergedReviewList = createSelector(
  reviewList,
  (state: ReviewListState): ReviewListResponse => {
    if (state.isSelectedReview) {
      const filteredContents = state.data.contents.filter(
        (review) => review.id !== state.selectedReviewData.contents[0]?.id,
      );

      return {
        ...state.data,
        contents: [...state.selectedReviewData.contents, ...filteredContents],
      };
    }

    return state.data;
  },
);
export const getIsSelectedReview = createSelector(
  reviewList,
  (state: ReviewListState) => state.isSelectedReview,
);
